// Zona horaria de reserva (Link Studios). Generado por huly-automation/patch/apply.sh
const resolvedOptions = Intl.DateTimeFormat.prototype.resolvedOptions
if (resolvedOptions.call(new Intl.DateTimeFormat()).timeZone === undefined) {
  Intl.DateTimeFormat.prototype.resolvedOptions = function (this: Intl.DateTimeFormat) {
    const options = resolvedOptions.call(this)
    return { ...options, timeZone: options.timeZone ?? 'UTC' }
  }
}

// Sin zona, Huly guarda «[null]» en la lista de zonas del reloj y su desplegable falla después.
try {
  const saved = JSON.parse(localStorage.getItem('TimeZones') ?? '[]')
  if (!Array.isArray(saved) || saved.some((tz) => typeof tz !== 'string' || tz === '')) localStorage.removeItem('TimeZones')
} catch {
  localStorage.removeItem('TimeZones')
}

export {}
